// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","steelColor":"#9a9a9a","button":"ButtonSecondaryTools_button__whvk6"};